<template>
    <div :class="columnDef">
        <q-select
            v-model="model"
            :options="options"
            :label="label"
            :name="name"
            dense
            outlined
            use-input
            hide-selected
            fill-input
            input-debounce="300"
            @filter="filterFn"
            clearable
            emit-value
            map-options
        >
            <template v-slot:no-option>
                <q-item>
                    <q-item-section class="text-grey">
                        No results
                    </q-item-section>
                </q-item>
            </template>
        </q-select>
        <input type="hidden" :name="name" :value="model" />
    </div>
</template>

<script>
import { ref, watch, onMounted } from "vue";
import axios from "axios";

export default {
    name: "DevUserSelect",
    props: {
        modelValue: {
            type: [String, Number],
            default: "",
        },
        name: {
            type: String,
            default: "causer_id",
        },
        label: {
            type: String,
            default: "User",
        },
        columnDef: {
            type: String,
            default: "col-12",
        },
    },
    setup(props, { emit }) {
        const model = ref(props.modelValue);
        const options = ref([]);

        watch(
            () => props.modelValue,
            (val) => {
                model.value = val;
            },
        );

        watch(model, (val) => {
            emit("update:modelValue", val);
        });

        const filterFn = (val, update, abort) => {
            if (val.length < 2) {
                abort();
                return;
            }

            axios
                .get("/dev/api/publishers", {
                    params: {
                        search: val,
                        limit: 20,
                    },
                })
                .then((response) => {
                    update(() => {
                        options.value = response.data.rows.map((user) => ({
                            label: `${user.firstName} ${user.lastName} (${user.email})`,
                            value: user.id,
                        }));
                    });
                })
                .catch(() => {
                    abort();
                });
        };

        onMounted(() => {
            if (model.value) {
                axios
                    .get("/dev/api/publishers", {
                        params: {
                            search: model.value,
                            limit: 1,
                        },
                    })
                    .then((response) => {
                        if (response.data.rows.length > 0) {
                            const user = response.data.rows[0];
                            options.value = [
                                {
                                    label: `${user.firstName} ${user.lastName} (${user.email})`,
                                    value: user.id,
                                },
                            ];
                        }
                    });
            }
        });

        return {
            model,
            options,
            filterFn,
        };
    },
};
</script>
